<template>
  <v-container class="py-10" id="infrastruktur">
    <v-row class="align-center">
      <v-col cols="12" lg="6" class="pr-10">
        <div class="subtitle" style="color:#d62b03">Organisation</div>
        <h2>Infrastruktur Überblick</h2>
        <p>
          Viele Organisationen geben an, Informationsbedarf zu haben. Eine
          Möglichkeit, diesen zu decken, sind externe Dienstleister.
          <b>56%</b> der Organisationen gaben an, externe Dienstleister
          einzusetzen. Die Organisationen holen sich externe Hilfe insbesondere
          bei der Systembetreuung (<b>41%</b>). Beratungsleistungen nehmen
          <b>25%</b> in Anspruch. Schulungen (<b>13%</b>) und Social Media
          Leistungen (<b>7%</b>) werden hingegen nur selten extern eingekauft.
        </p>
      </v-col>
      <v-col cols="12" lg="6">
        <v-row>
          <v-col cols="12" md="4">
            <v-card color="#d62b03" dark height="100%" elevation="0">
              <v-card-title class="display-1 justify-center pa-6"
                >18%</v-card-title
              >
              <v-card-text
                >haben einen festgelegten Prozess zur Anschaffung von
                IT.</v-card-text
              >
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card color="#d62b03" dark height="100%" elevation="0">
              <v-card-title class="display-1 justify-center pa-6"
                >61%</v-card-title
              >
              <v-card-text>nutzen Cloud Services.</v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card color="#d62b03" dark height="100%" elevation="0">
              <v-card-title class="display-1 justify-center pa-6"
                >30%</v-card-title
              >
              <v-card-text
                >bieten ihren Mitarbeitenden die Möglichkeit zur
                IT-Weiterbildung.</v-card-text
              >
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Infrastructureoverview",
  data: () => ({
    isActive: false
  })
};
</script>
